import React, { useEffect } from 'react'
import { ActivityIndicator, Image, StyleSheet } from 'react-native'

import MaskedView from '@react-native-masked-view/masked-view'
import { publishEvent } from '@zet/analytics'
import {
  B1,
  B2,
  B4,
  BTN_LG,
  Button,
  SH1,
  Stack,
  XStack,
} from '@zet/design-system'
import { useGetMagnetBenefits } from '@zet/feature-brands/api/brands/hooks'
import { IProductCard } from '@zet/feature-brands/utils/interface'
import { i18n } from '@zet/localization'
import { navigationRef } from '@zet/utils/navigation'
import { LinearGradient } from 'expo-linear-gradient'
import { ScrollView } from 'react-native-gesture-handler'

import Logo from '../../assets/svg/magnetLogo.svg'
import MultiStar from '../../assets/svg/multiStar.svg'
import { MagnetBenefitCard } from './magnetBenefitCard'

const MagnetCrossSellingCard = ({
  partnerId,
  customerId,
  isRecommendationFlow,
  isInEligible,
  index,
  leadSource,
  customerName,
  route,
}: IProductCard) => {
  const { data, isFetching } = useGetMagnetBenefits()

  useEffect(() => {
    publishEvent('widget_view', {
      widget_name: 'magent_cross_selling_leads_page',
    })
  }, [])

  const onPress = () => {
    publishEvent('click_action', {
      item_name: isRecommendationFlow
        ? 'brands_list_recommendation_brand_card'
        : 'brands_list_brand_card',
      brand_name: 'Magnet Credit Card',
      brand_category: 'Secured Credit Card',
      isLeadPageCrossSelling: true,
    })
    const routeObject = {
      brandId: partnerId,
      customerName: customerName,
      customerId: customerId,
      isEligible: !isInEligible,
      brandDetails: true,
      routeName: isRecommendationFlow ? 'forCustomerFlow' : 'category',
      index: index + 1,
      leadSource,
    }
    navigationRef.navigate('BrandDetails', routeObject)
  }

  return (
    <Stack className="w-full bg-white">
      <LinearGradient
        colors={['#791D8C', '#5928A8', '#452384', '#2C1E40']}
        start={[1, 0]}
        end={[0, 1]}
        locations={[0.18, 0.51, 0.63, 0.8]}
        className="m-3 rounded-xl"
      >
        <XStack className="justify-between px-3 pt-3">
          <Stack className="flex-1">
            <Logo />
            <Stack className="pt-3">
              <SH1 className="text-white">
                {i18n.t('magnetCrossSelling.Congratulations')}
              </SH1>
              <B2 className="text-white opacity-80">
                <B1 className="font-[Graphie-Bold]">{customerName}</B1>
                {i18n.t('magnetCrossSelling.eligibleForMagnet')}
              </B2>
            </Stack>
          </Stack>
          <Stack className="flex-1">
            <Image
              source={require('../../assets/images/magnetCard.png')}
              resizeMode="contain"
              style={styles.magnetCardImage}
            />
          </Stack>
        </XStack>
        <XStack className="items-center gap-1 px-3 pb-3">
          <MultiStar />
          <MaskedView
            maskElement={<B4>{i18n.t('magnetCrossSelling.FDBasesCC')}</B4>}
          >
            <LinearGradient
              colors={['#F0A534', '#FFCB42', '#FFECBA', '#FFBE5B']}
              start={[0, 0]}
              end={[1, 0.0]}
              locations={[0.0, 0.37, 0.7, 1]}
            >
              <B4 style={styles.zeroOpacity}>
                {i18n.t('magnetCrossSelling.FDBasesCC')}
              </B4>
            </LinearGradient>
          </MaskedView>
        </XStack>
        {isFetching ? (
          <Stack className="w-full items-center justify-center">
            <ActivityIndicator size={'large'} />
          </Stack>
        ) : (
          <ScrollView
            horizontal={true}
            showsHorizontalScrollIndicator={false}
            nestedScrollEnabled={true}
            className="w-full"
          >
            {data?.cardBenefit?.map((item, index) => {
              return <MagnetBenefitCard item={item} key={index} />
            })}
          </ScrollView>
        )}
        <Stack className="p-3">
          <Button fullWidth={true} className="bg-white" onPress={onPress}>
            <BTN_LG className="text-black">
              {i18n.t('magnetCrossSelling.shareMagnetApplicationLink')}
            </BTN_LG>
          </Button>
        </Stack>
      </LinearGradient>
    </Stack>
  )
}

const styles = StyleSheet.create({
  magnetCardImage: {
    height: 146,
    width: 186,
    marginTop: -40,
    marginLeft: -20,
    zIndex: 1,
  },
  zeroOpacity: { opacity: 0 },
})

export default MagnetCrossSellingCard
